import {useNavigate} from 'react-router-dom';
import {FlexiCancelButton} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {EditButton} from '../buttons/EditButton';
import {rbacActions} from '../../../config/rbac/actions';
import config from '../config';

// The person's page is a profile; editing happens in the Edit drawer. The
// console's copy also carried an in-page edit mode that nothing could switch
// on, so it was removed rather than kept as dead code (FNP-2015).
export const useEditPageTools = () => {
    const navigate = useNavigate();
    const {allowedActions} = useVerifiedPermissions();
    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateUser)) {
        tools.push(<EditButton key={'edit'}/>);
    }

    tools.push(<FlexiCancelButton key={'close'} onClick={() => navigate(config.basePath)}/>);

    return {tools};
};
